import { render, staticRenderFns } from "./PresentationHeading.vue?vue&type=template&id=abf19e08&scoped=true&"
import script from "./PresentationHeading.vue?vue&type=script&lang=js&"
export * from "./PresentationHeading.vue?vue&type=script&lang=js&"
import style0 from "./PresentationHeading.vue?vue&type=style&index=0&id=abf19e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf19e08",
  null
  
)

export default component.exports